import type { SxProps, Theme } from '@mui/material/styles';

export const attachmentGridStyles = {
	root: (size: 'compact' | 'large'): SxProps<Theme> =>
		size === 'large'
			? {
					display: 'grid',
					gridTemplateColumns: 'repeat(3, 1fr)',
					gap: 1,
					width: '100%'
				}
			: {
					display: 'flex',
					flexDirection: 'row',
					gap: 2,
					flexWrap: 'wrap'
				}
};
